import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuComponent } from './menu.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { StaySummaryMenuModule } from './components/stay-summary-menu/stay-summary-menu.module';
import { AirSummaryMenuModule } from './components/air-summary-menu/air-summary-menu.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PermissionModule } from "libraries/permission/permission.module";
import { StickyModule } from 'libraries/directive/sticky/sticky.module';
import { MenuService } from "./menu.service";
import {IsInArrayModule} from "../../../../pipes/is-in-array/is-in-array.module";

@NgModule({
    declarations: [
        MenuComponent,
    ],
    imports: [
        AirSummaryMenuModule,
        BtnModule,
        CommonModule,
        PermissionModule,
        RouterModule,
        StaySummaryMenuModule,
        AirSummaryMenuModule,
        FontAwesomeModule,
        StickyModule,
        IsInArrayModule
    ],
    exports: [
        MenuComponent
    ],
    providers: [MenuService],
})
export class MenuModule {}
